export function addSkipRegWallParamToHrefAttrIfNeeded(btn, job) {
  if (!job.apply_through_reg_wall) {
    return;
  }

  if(job.apply_by === 'by_form' || !window.$jBoard.config.do_not_proxy_apply_urls) {
    let hrefAttr = btn.attr('href');
    btn.attr('href', hrefAttr + '?skip-regwall=1');
  }
}
